import React, { useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Login } from "../../actions/Auth_action";
import { Change_LangugeHeader, change_Lang } from "../../actions/Helper_action";
import kurdish from "../../assets/images/kurd.png";
import english from "../../assets/images/eng.png";
import arabic from "../../assets/images/iraq.png";
import "./Login.css";
import { Redirect } from "react-router-dom";
import Swal from "sweetalert2";
import { Radio } from "antd";
const LoginTabset = () => {
  const [phone, setphone] = useState(0);
  const [password, setpassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [loginas, setloginas] = useState("Agent");
  const dispatch = useDispatch();
  const token = useSelector((state) => state.AuthReducer.token);
  const logo = useSelector((state) => state.HelperReducer.logo);
  const Login_User = (e) => {
    e.preventDefault();

    if (phone === 0 || password === "") {
      Swal.fire({
        title: "OPS",
        text: dispatch(
          change_Lang("Please fill out the password and Mobile Phone")
        ),
        icon: "error",
        html: `<b class="fk">${dispatch(
          change_Lang("Please fill out the password and Mobile Phone")
        )}</b>`,
        confirmButtonText: dispatch(change_Lang("Ok")),
        buttonsStyling: { fontFamily: "fk" },
        timer: 2000,
      });
    } else {
      const user = {
        phone,
        password,
        loginas,
      };
      dispatch(Login(user));
    }
  };
  const onChange_Radio = (e) => {
    setloginas(e.target.value);
  };
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  // key_lang=== object
  // krd === value
  const Change_Language_Kurdish = (e, language) => {
    e.preventDefault();
    localStorage.setItem("key_lang", "krd");
    window.document.body.classList.add("rtl");
    dispatch(Change_LangugeHeader(language));
  };
  const Change_Language_English = (e, language) => {
    e.preventDefault();
    localStorage.setItem("key_lang", "eng");
    window.document.body.classList.remove("rtl");
    dispatch(Change_LangugeHeader(language));
  };
  const Change_Language_Arabic = (e, language) => {
    e.preventDefault();
    localStorage.setItem("key_lang", "arb");
    window.document.body.classList.add("rtl");
    dispatch(Change_LangugeHeader(language));
  };
  if (token) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <img
          src={logo}
          className="img-fluid img-responsive"
          style={{
            opacity: 0.6,
            // height: 250,
            // width: 200,
          }}
          alt="logo"
          loading="lazy"
        />
      </div>
      <div className="form-horizontal mt-4">
        <div className="form-group">
          <input
            required
            type="number"
            className="form-control fk"
            placeholder={dispatch(change_Lang("phone_number"))}
            value={phone === 0 ? "" : phone}
            onChange={(e) => setphone(e.target.value)}
            autoComplete="off"
            autoFocus
            errorMessage="Invalid Phone number"
            onKeyPress={(event) =>
              event.key === "Enter" ? Login_User(event) : null
            }
          />
        </div>
        <div className="form-group">
          <input
            required
            type={`${passwordShown ? "text" : "password"}`}
            className="form-control fk"
            placeholder={dispatch(change_Lang("password"))}
            value={password}
            onChange={(e) => setpassword(e.target.value)}
            autoComplete="off"
            errorMessage="Invalid password field"
            onKeyPress={(event) =>
              event.key === "Enter" ? Login_User(event) : null
            }
          />
          <br />
          <label className="d-flex justify-content-center">
            <span
              className="fk"
              style={{ color: "white", fontWeight: "bold" }}
              onClick={togglePassword}
            >
              {dispatch(change_Lang("Show Password"))}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input
              value={passwordShown}
              onChange={(e) => setPasswordShown(e.target.checked)}
              className="checkbox_animated"
              id="chk-ani2"
              type="checkbox"
            />
            <Radio.Group onChange={onChange_Radio} value={loginas}>
              <Radio
                className="fk"
                style={{
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
                value={"Agent"}
              >
                {dispatch(change_Lang("Agent_"))}
              </Radio>
              <Radio
                className="fk"
                style={{
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
                value={"Realestate"}
              >
                {dispatch(change_Lang("Admin"))}
              </Radio>
            </Radio.Group>
          </label>
        </div>

        <div className="form-button row">
          <div className="col-1 d-lg-none"></div>
          <div className="col-3  col-sm-4  form-button">
            <button
              className={`btn btn-sm fk ${
                localStorage.getItem("key_lang") === "krd" ? "bg-secondary" : ""
              }`}
              onClick={(e) => Change_Language_Kurdish(e, "Kurdish")}
            >
              <img src={kurdish} alt="logo" className="flag-icon" />{" "}
              <span className="ayats d-none d-lg-inline">کوردی</span>
            </button>
          </div>
          <div className={`col-3 col-sm-4`}>
            <button
              className={`btn btn-sm ${
                localStorage.getItem("key_lang") === "eng" ? "bg-secondary" : ""
              }`}
              onClick={(e) => Change_Language_English(e, "English")}
            >
              <img
                src={english}
                className="flag-icon"
                style={{ padding: "2px 0px" }}
                alt="logo"
              />{" "}
              <span className={`ayats d-none d-lg-inline`}>Englsh</span>
            </button>
          </div>
          <div className="col-3 col-sm-4">
            <button
              className={`btn btn-sm fk ${
                localStorage.getItem("key_lang") === "arb" ? "bg-secondary" : ""
              }`}
              onClick={(e) => Change_Language_Arabic(e, "Arabic")}
            >
              <img src={arabic} alt="logo" className="flag-icon" />{" "}
              <span className="ayats d-none d-lg-inline">عربي</span>
            </button>
          </div>
          <div className="col-1 d-lg-none"></div>
        </div>
        {/* <div className="form-terms">
                <div className="custom-control custom-checkbox mr-sm-2">
                  <label className="d-block">
                    <span className="pull-right">
                      {" "}
                      <Link to="/lost-password" className="btn btn-default forgot-pass p-0 fk">
                        لەبیرچوونەوەی وشەی نهێنی
                      </Link>
                    </span>
                  </label>     
                </div>
              </div> */}
        <br />
        <div className="form-button text-center">
          <button
            className="btn btn-primary fk"
            type="submit"
            onClick={Login_User}
          >
            {dispatch(change_Lang("s_login"))}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default LoginTabset;
